import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { AuthLock, EyeCloseIcon, EyeIcon } from "asset/icons";
import Input from "component/form/Input";
import Loader from "component/loader";
import ErrorMessage from "pages/auth_v2/ErrorMessage";
import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const ForgotPinModal = ({ isOpen, onClose, onBack, onContinue, errorMessage, loading }) => {
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[600] bg-black/40 flex items-center justify-center">
            <div className="bg-white rounded-2xl w-full max-w-xl  relative">
                <div className="px-6 pt-6">
                    {/* Close Icon */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-2xl text-[#101828]"
                    >
                        <IoMdClose />
                    </button>

                    <div className="text-start">
                        {/* Icon */}
                        <AuthLock />

                        <div className="!px-5">
                            {/* Text */}
                            <h2 className="text-2xl font-semibold text-[#101828] mb-1">
                                Forgot PIN
                            </h2>
                            <p className="text-[#667085] mb-6">Enter your password</p>

                            {errorMessage && <ErrorMessage message={errorMessage} />}

                            {/* Input */}
                            <div className="relative">
                                <Input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(value) => setPassword(value, "password")}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-4 top-2/3 transform -translate-y-1/2 text-[#98A2B3]"
                                >
                                    {showPassword ? <EyeCloseIcon /> : <EyeIcon />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Buttons */}
                <div className="flex justify-end gap-4 border-t !p-5 items-center mt-8 text-sm">
                    <button onClick={onBack} className="text-[#344054] font-medium">
                        Back
                    </button>
                    <button
                        onClick={() => onContinue(password)}
                        disabled={!password || loading}
                        className={`rounded-lg px-6 py-2 font-medium transition text-white ${
                            !password || loading
                                ? "bg-[#E9D7FE] text-[#B3A8DD] cursor-not-allowed"
                                : "bg-[#6F00FF] hover:bg-[#5A00D6]"
                        }`}
                    >
                        {loading ? <Loader /> : "Continue"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ForgotPinModal;
